import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICmsFormFieldAbstractComponent } from '../abstract-field/icms-form-field.abstract.component';
import { ICmsFormFieldModel } from '../abstract-field/icms-form-field.model';

@Component({
    standalone: false,
    selector: 'icms-form-field',
    templateUrl: 'icms-form-field.html',
    styleUrls: ['../abstract-field/icms-field.scss', 'icms-form-field.scss'],
    providers: [ICmsFormFieldModel],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsFormFieldComponent extends ICmsFormFieldAbstractComponent {}
